import {FC, useCallback, useMemo, useState, ChangeEvent} from "react";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {GroupMembership} from "@memaro/api";
import {AdminGroupID, ViewerGroupID} from "../../../constants/groups.ts";
import Input from "@mui/material/Input";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import InlineSelect from "@memaro/components/InlineSelect.tsx";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";

export type TableRowNewProps = {
    onSave: (membership: GroupMembership) => void;
    saving: boolean;
}

const emptyGroupMembership: GroupMembership = {
    username: '',
    groupIDs: [ViewerGroupID],
}

const TableRowNew: FC<TableRowNewProps> = ({onSave, saving}) => {
    const [pendingMembership, setPendingMembership] = useState<GroupMembership>(emptyGroupMembership)

    const handleChangeUsernamePending = useCallback((e: ChangeEvent<HTMLInputElement>) =>
        setPendingMembership(prev => ({
            ...(prev ?? emptyGroupMembership),
            username: e.target.value
        })), [])

    const isPendingValid = useMemo(
        () => pendingMembership?.username && pendingMembership.groupIDs.length == 1,
        [pendingMembership]
    );

    const handleChangeGroup = useCallback((e: SelectChangeEvent) =>
        setPendingMembership(prev => ({
            ...(prev ?? emptyGroupMembership),
            groupIDs: [e.target.value]
        })), [])

    const handleSavePending = useCallback(() => {
        if (!pendingMembership) return;
        onSave(pendingMembership);
    }, [onSave, pendingMembership]);

    return (
        <TableRow>
            <TableCell component="th" scope="row">
                <Input
                    type="email"
                    value={pendingMembership.username}
                    onChange={handleChangeUsernamePending}
                    placeholder="E-mailadres"
                    disabled={saving}
                    required
                    autoFocus
                    size="small"
                    sx={{width: "100%"}}
                />
            </TableCell>
            <TableCell padding="none">
                <InlineSelect value={pendingMembership.groupIDs[0]} onChange={handleChangeGroup} disabled={saving}>
                    <MenuItem value={ViewerGroupID}>Bekijk</MenuItem>
                    <MenuItem value={AdminGroupID}>Beheer</MenuItem>
                </InlineSelect>
            </TableCell>
            <TableCell align="right" padding="none">
                <IconButton color="primary" onClick={handleSavePending} disabled={!isPendingValid} loading={saving}>
                    <CheckIcon/>
                </IconButton>
            </TableCell>
        </TableRow>
    )
}

export default TableRowNew
